(function() {
    const websiteSwitcherMenuActivationButton = document.querySelector('.navigation__lang');
    const websiteSwitcherMenu = document.querySelector('.navigation__country-website-switcher');
    const burgerMenuMainSection = document.querySelector('.navigation__sub');
    const navigationLangWrap = document.querySelector('.navigation__lang__wrap');

    websiteSwitcherMenuActivationButton.addEventListener('mouseenter', e => {
        websiteSwitcherMenu.classList.add('visible');
        websiteSwitcherMenu.classList.add('navigation__country-website-switcher-visible');
    });
    navigationLangWrap.addEventListener('mouseleave', e => {
        websiteSwitcherMenu.classList.remove('visible');
        websiteSwitcherMenu.classList.remove('navigation__country-website-switcher-visible');
    });

    // Events handlers for country switcher in footer
    document.querySelector('.lang-switcher-wrapper').addEventListener('mouseenter', e => {
        document.querySelector('.navigation__country-website-switcher.footer__item').classList.add('visible');
        document.querySelector('.navigation__country-website-switcher.footer__item').classList.add('navigation__country-website-switcher-visible');
    });
    // Events handlers for country switcher in footer
    document.querySelector('.lang-switcher-wrapper').addEventListener('mouseleave', e => {
        document.querySelector('.navigation__country-website-switcher.footer__item').classList.remove('visible');
        document.querySelector('.navigation__country-website-switcher.footer__item').classList.remove('navigation__country-website-switcher-visible');
    });

    document.querySelector('.navigation__country-website-switcher.footer__item').addEventListener('mouseleave', e => {
        document.querySelector('.navigation__country-website-switcher.footer__item').classList.remove('navigation__country-website-switcher-visible');
    });

    burgerMenuMainSection.addEventListener('mouseenter', e => {
        websiteSwitcherMenu.classList.remove('navigation__country-website-switcher-visible');
    });

})();